import React from 'react';
import { Theme } from '@mui/material/styles';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	onAccept: () => void;
	onCancel: () => void;
	open: boolean;
}

type Props = WithStyles<typeof styles> & OwnProps;

const DeleteShopperDialog = (props: Props) => {
	const { classes, open, onAccept, onCancel } = props;
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onCancel}>
			<DialogTitle className={classes.topSpacing}>
				{t(
					'shopperCard.areYouSureDeleteShopper',
					'Are you sure you want to delete the participant?',
				)}
			</DialogTitle>
			<DialogContent>
				<Typography variant="body2">
					{t('shopperCard.actionCouldNotBeUndone', `You won't be able to undo this action.`)}
				</Typography>
			</DialogContent>
			<DialogActions className={classes.paddingActions}>
				<Button onClick={onCancel} color="secondary">
					{t('common:actions.cancel')}
				</Button>
				<Button
					onClick={onAccept}
					color="primary"
					variant="contained"
					className={classes.errorColor}
				>
					{t('common:actions.delete')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		topSpacing: {
			paddingTop: theme.spacing(3),
		},
		paddingActions: {
			padding: theme.spacing(1, 3, 3),
		},
		errorColor: {
			backgroundColor: theme.palette.error.main,
			color: theme.palette.error.contrastText,
			'&:hover': {
				backgroundColor: theme.palette.error.dark,
			},
		},
	});

export default withStyles(styles)(DeleteShopperDialog);
